const formattedAddress = (address: string) => address.replace('+', ',');

export default formattedAddress;
